<template>
  <v-dialog
    v-model="dialog"
    :width="checkForm ? (qrStatus ? 1500 : 600) : 600"
    class="height-100"
  >
    <FirstPage :status="'invoice'" v-if="!checkForm" />
    <v-card v-else-if="checkForm && qrStatus">
      <v-card-title class="back-556C96 justify-center mb-5">
        <h3 class="color-white">출고양식 업로드</h3>
      </v-card-title>
      <v-row class="justify-center ma-0">
        <v-simple-table height="460" class="ma-3" fixed-header>
          <thead>
            <tr class=" color-white text-center">
              <th
                rowspan="2"
                class="color-white text-center border-right-white back-556C96 cursor-pointer"
                v-if="formDownStatus"
                @click="choiceAll"
              >
                전체선택
              </th>
              <th
                rowspan="2"
                class="color-white text-center border-right-white back-556C96"
                style="width:90px !important;"
              >
                발주차수
              </th>
              <th
                rowspan="2"
                class="color-white text-center back-556C96"
                style="width:110px !important;"
              >
                부위
              </th>
              <th
                :colspan="materialList.length"
                class="color-white text-center border-left-white back-556C96 "
                style="width:80px !important;"
              >
                규격(단위:TON)
              </th>
              <th
                rowspan="2"
                class="color-white text-center border-left-white back-556C96 "
                style="width:90px !important;"
              >
                발주수량
              </th>
            </tr>
            <tr>
              <th
                class="back-556C96 color-white text-center border-top-white border-left-white"
                v-for="list in materialList"
                :key="list.rebar_id"
              >
                {{ list.rebar_name }}
              </th>
            </tr>
          </thead>
          <tbody v-if="formDownStatus">
            <tr v-for="(list, index) in orderList" :key="list.orderId">
              <td class="border-left-aaaaaa border-bottom-aaaaaa text-center ">
                <input type="checkbox" v-model="checkList[index]" />
              </td>

              <td
                class="border-left-aaaaaa border-bottom-aaaaaa text-center pa-0"
                style="width:60px !important;"
              >
                {{ list.orderName }}
              </td>
              <td
                class="border-left-aaaaaa border-bottom-aaaaaa text-center pa-0"
                style="width:100px !important;"
              >
                {{ list.partName }}
              </td>
              <td
                class="border-left-aaaaaa border-bottom-aaaaaa text-center"
                v-for="(regacyInvoiceSum, index) in list.regacyInvoiceSumList"
                :key="index"
              >
                {{ mathRound(regacyInvoiceSum) }}
              </td>
              <td
                class="border-left-aaaaaa border-right-aaaaaa border-bottom-aaaaaa text-center"
              >
                {{ mathRound(list.allSum) }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr
              v-for="(invoice, index) in invoiceData"
              :key="invoice.orderName"
              class="text-center"
            >
              <td
                class="border-left-aaaaaa border-bottom-aaaaaa pa-0 pl-1 pr-1"
                style="width:60px !important;"
              >
                {{ invoice.orderName }}
              </td>
              <td
                class="border-left-aaaaaa border-bottom-aaaaaa pa-0 pl-1 pr-1"
                style="width:100px !important;"
              >
                {{ invoice.partName }}
              </td>
              <td
                v-for="i in tempList[index].length"
                :key="i"
                class="border-left-aaaaaa border-bottom-aaaaaa pl-2 pr-2"
              >
                <input
                  v-model.number="tempList[index][i - 1]"
                  class="text-center pa-0 border-aaaaaa width-50"
                  type="number"
                />
              </td>
              <td
                class="border-left-aaaaaa border-right-aaaaaa border-bottom-aaaaaa"
              >
                {{ sum(tempList[index]) }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-row>
      <v-row class="justify-center pb-5 mt-5 ml-0 mr-0">
        <v-btn
          color="#3F557D"
          width="150"
          height="40"
          class="color-white ml-3"
          @click="invoiceFileDown"
          v-if="formDownStatus"
          >확인</v-btn
        >
        <v-btn
          color="#eeeeee"
          width="150"
          height="40"
          class="ml-3"
          @click="cancelFileDown"
          v-if="formDownStatus"
        >
          뒤로가기</v-btn
        >
        <v-btn
          color="#6C98EB"
          width="150"
          height="40"
          class="color-white ml-3"
          @click="invoiceUpload"
          v-if="!formDownStatus"
        >
          업로드</v-btn
        >
        <v-btn
          color="#eeeeee"
          width="150"
          height="40"
          class="ml-3"
          @click="cancelFileDown"
          v-if="!formDownStatus"
        >
          뒤로가기</v-btn
        >
      </v-row>
    </v-card>
    <v-card v-else-if="checkForm && !qrStatus">
      <v-card-title class="back-556C96 justify-center mb-5">
        <h3 class="color-white">출고양식 업로드</h3>
      </v-card-title>
      <v-row class="justify-center ma-0 pt-1 pa-0">
        <qr-code :text="qrString" size="150" color="#000000"></qr-code>
      </v-row>
      <v-row class="justify-start pl-4 ma-0 pa-0">
        <h3>Qr코드 링크 URL :</h3>
      </v-row>
      <v-row class="justify-start pl-4 ma-0  pa-0">
        <a :href="qrString">{{ qrString }}</a>
      </v-row>
      <v-row class="justify-center pb-5 mt-5 ma-0 ">
        <v-btn
          color="#3F557D"
          width="183"
          height="53"
          rounded
          class="color-white ml-3"
          v-clipboard:copy="qrString"
          >QR링크 복사</v-btn
        >
        <v-btn
          color="#718FC7"
          width="183"
          height="53"
          rounded
          class="color-white ml-3"
          @click="dialog = !dialog"
        >
          확인</v-btn
        >
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import FirstPage from "./form/FirstPage.vue";
import InvoiceApi from "@/api/InvoiceService";
import FileApi from "@/api/FileService";
import XLSX from "xlsx";
import fileDownload from "@/assets/js/file-download.js";
import Commonality from "@/mixin/Commonality";
import VueQRCodeComponent from "vue-qrcode-component";
export default {
  components: {
    FirstPage,
    "qr-code": VueQRCodeComponent,
  },
  mixins: [Commonality],
  created() {
    this.$bus.$on("orderListShow", async () => {
      let res = await InvoiceApi.invoiceOrderList({
        constructionId: this.constructionId,
      });
      this.orderList = res.data.orderList;
      this.formDownStatus = true;
      this.checkForm = true;
    });
    this.$bus.$on("InvoiceForm", (value) => {
      this.dialog = value;
    });
    this.$bus.$on("invoiceFileSearch", async (file) => {
      this.file = file;
      await this.upload();
    });
  },
  beforeDestroy() {
    this.$bus.$off("orderListShow");
    this.$bus.$off("InvoiceForm");
    this.$bus.$off("invoiceFileSearch");
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$bus.$emit("fileClear");
        this.checkForm = false;
        this.qrStatus = true;
      }
    },
  },
  computed: {
    header() {
      let list = ["orderName", "partName", "dong", "floor", "type", "status"];
      for (let i = 0; i < this.materialList.length; i++) {
        list.push(this.materialList[i].rebar_name);
      }
      list.push("totalSum", "orderDate", "registeDate");
      return list;
    },
  },
  data: function() {
    return {
      dialog: false,
      orderList: "",
      checkList: [],
      checkForm: false,
      file: "",
      formDownStatus: false,
      invoiceData: [],
      uploadStatus: false,
      tempList: [],
      qrString: "",
      qrStatus: true,
    };
  },
  methods: {
    choiceAll() {
      let trueList = [];
      let falseList = [];
      let trueOrFalse = false;
      for (let i = 0; i < this.orderList.length; i++) {
        trueList.push(true);
        falseList.push(false);
        if (this.checkList[i] != true) trueOrFalse = true;
      }
      if (trueOrFalse) this.checkList = trueList;
      else this.checkList = falseList;
    },
    upload() {
      let reader = new FileReader();
      reader.onload = () => {
        let data = reader.result;
        let workbook = XLSX.read(data, {
          type: "binary",
          cellDates: true,
          dateNF: "yyyy-mm-dd",
        });
        workbook.SheetNames.forEach((sheetName) => {
          const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
            header: this.header,
            dateNF: "YYYY-MM-DD",
            raw: false,
          });
          if (roa[0].orderName != "발주 입고 시스템 일괄 엑셀 출고 양식") {
            this.$bus.$emit(
              "dialog",
              "발주 양식이 아닙니다. 양식 다운로드을 업로드 해주세요."
            );
            this.uploadStatus = true;
            return;
          }
          if (roa[1].partName != this.constructionName.constructionName) {
            this.$bus.$emit("dialog", "현재 현장과 다른 현장입니다.");
            this.uploadStatus = true;
            return;
          }
          let startNumber = 0;
          let list = [];
          let tempList = [];
          let totalSum = 0;
          for (let i = 3; i < roa.length; i += 2) {
            if (roa[i].orderName) {
              tempList[startNumber] = [];
              list[startNumber] = {};
              list[startNumber].constructionId = this.constructionId;
              list[startNumber].orderName = roa[i].orderName;
              list[startNumber].partName = roa[i].partName;
              list[startNumber].dong = roa[i].dong;
              list[startNumber].floor = roa[i].floor;
              list[startNumber].type = roa[i].type;
              list[startNumber].registeDate = roa[i + 1].registeDate
                ? roa[i + 1].registeDate
                : this.$moment(new Date()).format("YYYY-MM-DD");
              list[startNumber].rebarListData = [];
              for (let j = 0; j < this.materialList.length; j++) {
                tempList[startNumber][j] = this.regexForData(
                  roa[i + 1][this.materialList[j].rebar_name]
                );
                list[startNumber].rebarListData.push({
                  rebarName: this.materialList[j].rebar_name,
                  rebarValue: this.regexForData(
                    roa[i + 1][this.materialList[j].rebar_name]
                  ),
                });
                totalSum += this.regexForData(
                  roa[i + 1][this.materialList[j].rebar_name]
                );
              }
              startNumber++;
            }
          }
          if (totalSum == 0) {
            this.$bus.$emit("dialog", "입력된 데이터가 없습니다.");
            this.uploadStatus = true;
            return;
          }
          this.invoiceData = list;
          this.tempList = tempList;
          this.formDownStatus = false;
          this.checkForm = !this.checkForm;
        });
      };
      reader.readAsBinaryString(this.file);
    },
    async invoiceFileDown() {
      this.$bus.$emit("loadingStart");
      let list = {
        constructionId: this.constructionId,
        invoiceFormatDTO: [],
      };
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.checkList[i]) list.invoiceFormatDTO.push(this.orderList[i]);
      }
      let res = await FileApi.invoiceStyleDown(list);
      if (res.data) {
        fileDownload(
          res.data,
          `${this.constructionName.constructionName} 출고양식.xlsx`
        );
        this.cancelFileDown();
      }
      this.$bus.$emit("loadingEnd");
    },
    cancelFileDown() {
      this.checkForm = !this.checkForm;
      this.checkList = [];
    },
    async invoiceUpload() {
      let data = {
        constructionId: this.constructionId,
        invoiceData: [
          {
            oneRow: [],
          },
        ],
        selectDate: null,
      };
      for (let i = 0; i < this.invoiceData.length; i++) {
        for (let j = 0; j < this.tempList[i].length; j++) {
          this.invoiceData[i].rebarListData[j].rebarValue = this.tempList[i][j];
        }
        data.invoiceData[0].oneRow[i] = this.invoiceData[i];
      }
      data.invoiceData[0].oneRow = this.invoiceData;
      let res = await InvoiceApi.invoiceCreate(data);
      if (res.data.success == "ok") {
        this.qrString = `${window.location.protocol}//${window.location.host}/qrCode?qrText=${res.data.resultInvoice[0].qrString}`;
        this.qrStatus = !this.qrStatus;
      } else {
        this.$bus.$emit("dialog", res.data.reason);
      }
      this.$bus.$emit("invoiceNavigationDuplicated");
    },
  },
};
</script>

<style scoped>
.width-50 {
  width: 50px;
}
</style>
